import { FC, useEffect, useState } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";
import SelectBox from "../../shared/base-components/SelectBox";
import DatePicker from "../../shared/base-components/DatePicker";
import {
  useCustomerPaymentAddMutation,
  useCustomerPaymentMutation,
} from "./CustomerProfile.actions";
import { getItem } from "../../shared/hooks/useCookie";
import {
  CustomerAllPaymentRequest,
  CustomerAllPaymentResponse,
  CustomerPaymentRequest,
  CustomerProfileResponse,
  paymentModalschema,
} from "./CustomerProfile.constants";
import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { successNotify } from "../../shared/utils/notifications";
import { yupResolver } from "@hookform/resolvers/yup";
import Switch from "../../shared/base-components/Switch";

interface CustomerPaymentModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  customerProfilData?: CustomerProfileResponse;
  mutate: UseMutateFunction<
    CustomerProfileResponse,
    AxiosError<any>,
    any,
    unknown
  >;
  customerAllPaymentMutation: UseMutateFunction<
    CustomerAllPaymentResponse,
    AxiosError<any>,
    CustomerAllPaymentRequest,
    unknown
  >;
}

const CustomerPaymentModal: FC<CustomerPaymentModalProps> = ({
  isModalOpen,
  toggle,
  customerProfilData,
  customerAllPaymentMutation,
}) => {
  const customerProfileId = getItem("customerProfileId");

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<any>({
    resolver: yupResolver(paymentModalschema),
  });

  const {
    data,
    mutate: customerPaymentMutate,
    isLoading,
  } = useCustomerPaymentMutation();
  const { data: customerPaymentAddData, mutate: customerPaymentAddMutation } =
    useCustomerPaymentAddMutation();

  const [paymentType, setPaymentType] = useState("ap");
  const [hasNextPaymentDate, setHasPaymentDate] = useState(false);

  const onSubmit: SubmitHandler<any> = (
    requestFormValues: CustomerPaymentRequest
  ) => {
    if (customerProfilData?.customer_devices[0]?.device?.id) {
      customerPaymentMutate({
        ...requestFormValues,
        customer: customerProfileId,
        payment_type: paymentType,
        device: customerProfilData?.customer_devices[0]?.device?.id,
        next_payment_date: requestFormValues?.next_payment_date || undefined,
      });
    }
  };

  useEffect(() => {
    if (data?.name_of_payment.length) {
      // customerPaymentAddMutation({
      //   amount: parseInt(watch("amount")) - parseInt(watch("got_amount")),
      //   payment: data.id,
      //   payment_type: 1,
      //   is_paid: false,
      //   is_partial: false,
      //   payment_date: selectedDate,
      // });
      customerAllPaymentMutation({ id: customerProfileId });
      successNotify("Ödeme başarılı bir şekilde eklendi.");
      toggle();
    }
  }, [data]);

  return (
    <ModalComponent
      header="Yeni Ödeme Ekle"
      description="Yeni Ödeme eklemek için gerekli alanları doldurunuz."
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Ödeme Tipi</Label>
              <SelectBox
                control={control}
                name="payment_type"
                className="form-control"
                onChangeHandler={(e) => setPaymentType(e.target.value)}
                options={[
                  { key: "Peşin Ödeme", value: "ap" },
                  { key: "Taksitli Ödeme", value: "ip" },
                ]}
              />
            </FormGroup>
          </Col>

          <>
            <Col sm="12" md="6" lg="6">
              <FormGroup className="mb-3">
                <Label className="form-label">Ödeme Adı</Label>
                <TextField
                  control={control}
                  name="name_of_payment"
                  type="text"
                  className="form-control"
                  placeholder="Ödeme Adı"
                  error={errors.name_of_payment?.message}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="6" lg="6">
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Yapılan İş Ücreti</Label>
                <TextField
                  control={control}
                  name="amount"
                  className="form-control"
                  type="number"
                  placeholder="Yapılan İş Ücreti"
                  error={errors.amount?.message}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="6" lg="6">
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Alınan İş Ücreti</Label>
                <TextField
                  control={control}
                  name="got_amount"
                  className="form-control"
                  type="number"
                  placeholder="Alınan İş Ücreti"
                  error={errors.got_amount?.message}
                />
              </FormGroup>
            </Col>

            <Col sm="12" md="12" lg="12">
              <FormGroup className="mb-3">
                <Label htmlFor="validationCustom02">Not</Label>
                <TextField
                  control={control}
                  name="note"
                  className="form-control"
                  type="text"
                  placeholder="Not"
                />
              </FormGroup>
            </Col>

            {paymentType === "ap" && (
              <>
                <Col sm="12" md="6" lg="6">
                  <FormGroup>
                    <Label style={{ margin: 0 }} htmlFor="validationCustom02">
                      Sonraki Ödeme Tarihi
                    </Label>
                  </FormGroup>
                  <Switch
                    onChangeHandler={(e: any) => setHasPaymentDate(e)}
                    control={control}
                    defaultValue={false}
                    name="has_next_Payment_date"
                  />
                </Col>

                <Col sm="12" md="6" lg="6">
                  {hasNextPaymentDate && (
                    <FormGroup className="mb-3">
                      <Label htmlFor="validationCustom02">Tarih</Label>
                      <DatePicker
                        control={control}
                        name="next_payment_date"
                        className="form-control"
                        type="text"
                        defaultValue={new Date()}
                      />
                    </FormGroup>
                  )}
                </Col>
              </>
            )}

            {paymentType === "ip" && (
              <>
                <Col sm="12" md="6" lg="6">
                  <FormGroup className="mb-3">
                    <Label htmlFor="validationCustom02">
                      Taksit Başlangıç Tarihi
                    </Label>
                    <DatePicker
                      control={control}
                      name="date_of_installment"
                      className="form-control"
                      defaultValue={new Date()}
                    />
                  </FormGroup>
                </Col>

                <Col sm="12" md="6" lg="6">
                  <FormGroup className="mb-3">
                    <Label htmlFor="validationCustom02">Taksit Sayısı</Label>
                    <TextField
                      control={control}
                      name="number_of_installment"
                      className="form-control"
                      type="number"
                      placeholder="Taksit Sayısı"
                      error={errors.number_of_installment?.message}
                    />
                  </FormGroup>
                </Col>
              </>
            )}
          </>

          <Col md="12">
            <FormGroup className="mb-3">
              <Button loading={isLoading} text="Ödeme Ekle" variant="primary" />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default CustomerPaymentModal;
